module.exports = __webpack_public_path__ + "img/copy.ba1c510c.svg";